import React from 'react';
import PaymentMethods from '@separate/components/PaymentMethods';
import { useSubscriptionQuery } from '@separate/hooks/premium';
import { useTranslation } from '@separate/hooks/translation';
import { useQueryUserProfile } from '@separate/hooks/user';
import { formatLocalDateSimple } from '@separate/utilities/datetime';
import { asCurrency } from '@separate/utilities/string';
import InfoRow from '../Main/BasicInfo/InfoRow';
import styles from './accountInfo.module.scss';

export default function AccountInfo() {
  const { subscription } = useSubscriptionQuery();
  const { t } = useTranslation();
  const { user } = useQueryUserProfile();

  const intervalMapping = {
    year: {
      interval: t('user.profile.annual_interval'),
      plan: t('user.profile.annual_plan'),
    },
    month: {
      interval: t('user.profile.monthly_interval'),
      plan: t('user.profile.monthly_plan'),
    },
  };

  const planInterval = intervalMapping[subscription?.interval || 'month'];

  const ref = React.createRef();

  return (
    <div ref={ref}>
      <div className="d-flex w-100 justify-content-between">
        <h4 className={styles.ctaTitle}>
          {t('user.profile.account_info')}
        </h4>
      </div>

      {user && subscription && (
        <div className={styles.infoContainer}>
          <InfoRow label={t('user.profile.plan')}>
            {`${planInterval?.plan}`}
          </InfoRow>
          <InfoRow label={t('user.profile.price')}>
            {`${asCurrency(subscription.price / 100) } / ${planInterval?.interval}`}
          </InfoRow>
          {subscription.next_payment_attempt && (
            <InfoRow label={t('user.profile.next_billing')}>
              {`${formatLocalDateSimple(subscription.next_payment_at)}`}
            </InfoRow>
          )}
        </div>
      )}

      <PaymentMethods container={ref} />
    </div>
  );
}
